import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { captureIntendedRoute } from "@/lib/authReturnTo";
import { Leaf } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading, suppressCaptureRef } = useAuth();
  const location = useLocation();

  // Stash the intended URL BEFORE the redirect mounts, so a follow-up
  // re-authentication (Continue with Google → AuthCallback) can restore
  // the user to whatever page they were trying to reach — not the generic
  // /home. Only fires when we're actually about to bounce (not while loading),
  // AND we're not in the middle of a sign-out (`suppressCaptureRef.current`
  // is set by AuthContext.signOut for a brief window so we don't capture
  // the page the user was signing out FROM).
  useEffect(() => {
    if (loading || user) return;
    if (suppressCaptureRef?.current) return;
    captureIntendedRoute(location);
  }, [loading, user, location, suppressCaptureRef]);

  if (loading) {
    return (
      <div className="app-shell flex items-center justify-center">
        <Leaf className="w-6 h-6 text-leaf animate-pulse" strokeWidth={1.5} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
